export function normalizeBottomNavComparableUrl(url: string): string {
  return url.split("?")[0].replace(/\/+$/, "").toLowerCase();
}

/** Longest prefix match among bottom-nav routes (avoids parent `/elearning` staying active on `/elearning/sessions`). */
export function resolveBottomNavActiveRoute(
  currentUrl: string,
  navRoutes: readonly string[]
): string | null {
  const current = normalizeBottomNavComparableUrl(currentUrl);
  let bestRoute: string | null = null;
  let bestLength = -1;

  for (const route of navRoutes) {
    const normalized = normalizeBottomNavComparableUrl(route);
    if (!normalized) {
      continue;
    }

    const matches = current === normalized || current.startsWith(`${normalized}/`);
    if (matches && normalized.length > bestLength) {
      bestRoute = normalized;
      bestLength = normalized.length;
    }
  }

  return bestRoute;
}

export function isBottomNavItemActive(
  itemRoute: string,
  currentUrl: string,
  navRoutes: readonly string[]
): boolean {
  const activeRoute = resolveBottomNavActiveRoute(currentUrl, navRoutes);
  if (!activeRoute) {
    return false;
  }

  return normalizeBottomNavComparableUrl(itemRoute) === activeRoute;
}
